import script from "./IndexProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexProduct.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__